export default __webpack_public_path__ + "static/media/sitemap.e47bdc7c.jpg";